import type { ReactElement } from 'react';

import type { TipCardConfig } from '../../types';

import { useGetTipActions } from './useGetTipActions';
import { useVerifyStrengthTips } from './useVerifyStrengthTips';

export function useGetPetitionStrengthTips(): { tips: TipCardConfig[]; decisionMakerModal: ReactElement } {
	const selectedTips = useVerifyStrengthTips();
	const [getActions, decisionMakerModal] = useGetTipActions();

	const tips = selectedTips.map((tip) => {
		return {
			...tip,
			// dynamic properties
			...getActions(tip.type),
		};
	});

	return { tips, decisionMakerModal };
}
